/**
 * AD Attack Paths - Category Index
 *
 * Combines all AD attack path query categories into a single export.
 *
 * ## Adding a New Query
 *
 * 1. Find the appropriate category file (ad-kerberos.ts, ad-hygiene.ts, etc.)
 * 2. Add your query object to the array in that file
 * 3. Done! The query will automatically be included.
 *
 * ## Adding a New Category
 *
 * 1. Create a new file: `ad-my-category.ts`
 * 2. Export an array: `export const AD_MY_CATEGORY_QUERIES: SavedQuery[] = [...]`
 * 3. Import and spread it into AD_ATTACK_PATH_QUERIES below
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { AD_DANGEROUS_PRIVS_QUERIES } from './ad-dangerous-privs';
// Category imports
import { AD_DOMAIN_INFO_QUERIES } from './ad-domain-info';
import { AD_HYGIENE_QUERIES } from './ad-hygiene';
import { AD_KERBEROS_QUERIES } from './ad-kerberos';
import { AD_SHORTEST_PATHS_QUERIES } from './ad-shortest-paths';

/**
 * All AD attack path queries combined.
 * Order matters for display - queries appear in this order within the AD Attack Paths folder.
 */
export const AD_ATTACK_PATH_QUERIES: SavedQuery[] = [
  ...AD_DOMAIN_INFO_QUERIES,
  ...AD_DANGEROUS_PRIVS_QUERIES,
  ...AD_SHORTEST_PATHS_QUERIES,
  ...AD_KERBEROS_QUERIES,
  ...AD_HYGIENE_QUERIES,
];
